import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import Textbox from '../../textbox';

const AddressLineTwoField = ({ error, ...props }) => {
  return (
    <Textbox
      label={I18n.t('registration.company_details.fields.address2.label')}
      name="address2"
      placeholder={I18n.t('registration.company_details.fields.address2.label')}
      error={!!error}
      errorMsg={error}
      className="input--address-line-two"
      {...props}
    />
  );
};

export default AddressLineTwoField;
